import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const Loader = () => {
  return (
    <div>
      <Box sx={{ display: "flex", height: "60vh", width: "100%", justifyContent: "center", alignItems: "center" }}>
        <CircularProgress />
      </Box>
    </div>
  );
};

export default Loader;
